import { useQuery } from '@tanstack/react-query';
import { registration } from '@/api';
import { useTenantApi } from '@/account/hook/useTenantApi';

export function useFormMetadataListQuery(params: registration.LoadEventFormMetaListRequest) {
  const { createTenantAdminApiRequest, isLoading: isApiPreparing } = useTenantApi();
  return useQuery<registration.LoadFormMetadataResponse, Error>({
    queryKey: [registration.formMetaListQueryKey, params],
    queryFn: async () => {
      return await registration.loadFormMetadataList(createTenantAdminApiRequest)(params);
    },
    enabled: !isApiPreparing,
  });
}
